import React from 'react';
export default function timeTakePlace(props) {
    const {leftText, centerText, rightText,} = props
   return (
    <span>
        <span style={{minWidth: 80,textAlign: 'right',display: 'inline-block'}}>{leftText}</span>
        <span style={{minWidth: 60}}>
        <span>{centerText}</span>
        </span>
        <span style={{minWidth: 80, textAlign: 'left', display: 'inline-block'}}>{rightText}</span>
    </span>
   )
}